module.exports = __webpack_public_path__ + "static/media/blog-ads-vs-reco-banner@2x.65ec5d6d.jpg";